var map = {
	"./back-light.jpg": 6677,
	"./back.jpeg": 2716,
	"./beer.gif": 9339,
	"./beer.png": 9483,
	"./beer_last.png": 3625,
	"./beer_prelast.png": 6002,
	"./bikes-group-A.png": 4856,
	"./bikes-group-B.png": 4862,
	"./bikes-group-C.png": 2213,
	"./bikes-group-D.png": 8332,
	"./bikes-group.jpg": 5294,
	"./bikes-group.png": 1289,
	"./bikes.jpg": 9443,
	"./boat.png": 1827,
	"./island.png": 1141,
	"./island.webp": 9262,
	"./logo-green.png": 5453,
	"./logo.png": 6949,
	"./road.jpg": 1393,
	"./sea.png": 48,
	"./stan-door-crop-revert.png": 4225,
	"./stan-door-crop.png": 3529,
	"./stan-door.jpg": 5596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2777;